// extracted by mini-css-extract-plugin
export default {"container":"styles_container__KzXMR","containerChild":"styles_containerChild__ufsLR"};